import React from 'react';
import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import CompleteLevelButton from 'components/completeLevelButton';

import balloonSlide from '../../baseSlides/balloonSlide';

import esGooberGoofySmile from '../../images/characters/esmeralda_goober_goofy_smile.png';
import esGooberProud from '../../images/characters/esmeralda_goober_proud.png';
import esGooberWave from '../../images/characters/esmeralda_goober_wave.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './finish.md';

const md = new MarkdownScript(markdownFile);

import imgLevel1Complete from './level-1_complete.svg';
import imgLevel2Complete from './level-2_complete.svg';
import imgLevel3Complete from './level-3_complete.svg';
import imgLevel4Complete from './level-4_complete.svg';
import imgLevel5Complete from './level-5_complete.svg';
import imgLevel6Complete from './level-6_complete.svg';

const levels = {
  '1': { img: imgLevel1Complete },
  '2': { img: imgLevel2Complete },
  '3': { img: imgLevel3Complete },
  '4': { img: imgLevel4Complete },
  '5': { img: imgLevel5Complete },
  '6': { img: imgLevel6Complete }
};

export function preloadFinish () {
  preloader([
    esGooberGoofySmile,
    esGooberProud,
    esGooberWave,
    ianSaraSide,
    ianSaraLeanQuestioning,
    imgLevel1Complete,
    imgLevel2Complete,
    imgLevel3Complete,
    imgLevel4Complete,
    imgLevel5Complete,
    imgLevel6Complete
  ]);
}

function finishSection ({ level, regionData }) {
  return (
    <Section id="finish">

      {/* Scoreboard Recap */}
      { (level !==6) &&
        balloonSlide({
          id: 'scoreboard-recap',
          characterSide: 'left',
          characterImage: ianSaraSide,
          html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
        })
      }

      {/* Earn More Points */}
      { (level !==6) &&
        balloonSlide({
          id: 'earn-more-points',
          characterSide: 'right',
          characterImage: ianSaraLeanQuestioning,
          html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
        })
      }

      {/* Farewell levels 1 & 4 */}
      { (level === 1 || level === 4) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'right',
          characterImage: esGooberGoofySmile,
          html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
        })
      }

      {/* Farewell levels 2 & 5 */}
      { (level === 2 || level === 5) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'left',
          characterImage: esGooberProud,
          html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
        })
      }

      {/* Farewell levels 3 */}
      { (level === 3) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'left',
          characterImage: esGooberWave,
          html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
        })
      }

      {/* Level complete */}
      <Slide
      id="level-completed"
      notes={'<h2>Level ' + level + ' Finished</h2>'}
      bgColor="transparent"
      finish>
        <div className="level-complete">
          <div className="level-complete-content">
              <figure className="level-complete-graphic"><img src={levels[level].img}/></figure>
              <Heading size={2}>
                You've finished
              </Heading>
              <Heading size={2}>
                level {level} of 6
              </Heading>
              <CompleteLevelButton/>
          </div>
        </div>
      </Slide>

    </Section>
  );
}

export default finishSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/90_finish/finishSection.jsx